module.exports = __webpack_public_path__ + "img/freight-carrier.a49293c.svg";